import React, { useEffect, useState } from "react";
import DTOFeedbackDetailModal from "./DTOFeedbackDetailModal";
import FeedbackDetailModalPresenter from "./FeedbackDetailModalPresenter";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const FeedbackDetailModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  return (
    <div>
      <DTOFeedbackDetailModal />

      <FeedbackDetailModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
      />
    </div>
  );
};

export default FeedbackDetailModalController;
